import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-empty-data',
  templateUrl: './empty-data.component.html',
  styleUrls: ['./empty-data.component.scss']
})
export class EmptyDataComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() icon: string;
  @Input() containerClass: string;
  @Input() iconSize: string;
  @Input() iconColor: string;
  @Input() titleSize: string;
  @Input() titleColor: string;
  @Input() messageSize: string;
  @Input() messageColor: string;
}
